module.exports = __webpack_public_path__ + "static/media/icon-sneak-peek.42112233.png";